<!--
 * @Author: your name
 * @Date: 2021-07-23 16:28:02
 * @LastEditTime: 2021-07-29 11:46:12
 * @LastEditors: Please set LastEditors
 * @Description: 弹框
 * @FilePath: \contingency-manage\src\components\global\XDialog.vue
-->
<template>
  <div
    class="XDialogBox"
    ref="xDialogRef"
    :class="{ hide: !modelValue }"
    :style="{
      zIndex: zIndex,
    }"
  >
    <div
      class="XDialog"
      v-if="modelValue"
      :style="{
        height: height,
        width: width,
      }"
    >
      <div class="topTitle">
        <div class="title">{{ title }}</div>
        <div class="topColse" @click.prevent="closeDialog">
          <x-icon size="24px" type="icon-guanbi2"></x-icon>
        </div>
      </div>
      <div class="xDialogContent">
        <div class="dialogCount">
          <slot></slot>
        </div>
        <div class="dialogBottom">
          <slot name="button"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  defineComponent,
  onMounted,
  onBeforeUnmount,
  ref,
  reactive,
  toRefs,
} from "vue";
import XIcon from "./XIcon.vue";
export default defineComponent({
  name: "HDialog",
  components: { XIcon },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "标题",
    },
    height: {
      type: String,
      default: "300px",
    },
    width: {
      type: String,
      default: "500px",
    },
    zIndex: {
      type: String,
      default: "9",
    },
  },
  emits: ["update:modelValue", "close"],
  setup(props, context) {
    const xDialogRef = ref(null);
    const data = reactive({
      addBody: false,
    });
    const refData = toRefs(data);
    // 关闭弹框
    const closeDialog = () => {
      context.emit("close");
      context.emit("update:modelValue", false);
    };

    const appendChildEl = () => {
      if (xDialogRef.value) {
        data.addBody = true;
        document.body.appendChild(xDialogRef.value);
      }
    };
    const removeChildEl = () => {
      if (xDialogRef.value && data.addBody) {
        xDialogRef.value.parentNode.removeChild(xDialogRef.value);
      }
    };
    onMounted(() => {
      appendChildEl();
    });
    onBeforeUnmount(() => {
      removeChildEl();
    });
    return { ...refData, closeDialog, xDialogRef };
  },
});
</script>

<style lang='scss' scoped>
.XDialogBox {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99;
  background-color: rgba($color: #000000, $alpha: 0.6);
  pointer-events: auto;
  &.hide {
    width: 0;
    height: 0;
    overflow: hidden;
  }
  .XDialog {
    width: 500px;
    height: 300px;
    background: rgba(3, 23, 68, 0.7);
    // box-shadow: 0 0 10px 3px #004472 inset;
    // border-radius: 4px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    z-index: 5;
    padding: 20px;
    color: #fff;
    z-index: 9;
    // @include flex-col-s-c;
    .topTitle {
      width: 100%;
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #6a7795;
      padding-bottom: 10px;
      position: relative;
      &::before {
        content: "";
        width: 6px;
        height: 2px;
        position: absolute;
        bottom: -1px;
        left: 0;
        background-color: #fff;
      }
      .topColse {
        cursor: pointer;
      }
    }
    .xDialogContent {
      width: 100%;
      // flex: 1;
      height: calc(100% - 30px);
      padding-top: 10px;
      @include flex-col-s-c;
      .dialogCount {
        width: 100%;
        flex: 1;
        position: relative;
        // overflow: hidden;
      }
      .dialogBottom {
        width: 100%;
        // height:20%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 20px;
        .button {
          height: 30px;
          width: 90px;
        }
      }
    }
  }
}
</style>